'use strict';

var uncurryThis = require('../internals/function-uncurry-this');

var ArrayBufferViewCore = require('../internals/array-buffer-view-core');

var $arrayUniqueBy = require('../internals/array-unique-by');

var fromSpeciesAndList = require('../internals/typed-array-from-species-and-list');

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var arrayUniqueBy = uncurryThis($arrayUniqueBy); // `%TypedArray%.prototype.uniqueBy` method
// https://github.com/tc39/proposal-array-unique

exportTypedArrayMethod('uniqueBy', function uniqueBy(resolver) {
  return fromSpeciesAndList(this, arrayUniqueBy(aTypedArray(this), resolver));
}, true);